import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TBrand, TBrandPayloadRequest, TBrandResponse, adaptBrandFromResponse, adaptBrandToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_BRAND } from '../../backend-paths';


export const brandCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_BRAND}`,
	(payload: TBrandPayloadRequest, thunkApi) => {
		const dataRequest = adaptBrandToRequest(payload);

		return HttpService.post<TBrandResponse>(BACKEND_ADMIN_BRAND, dataRequest).then(result => {
			return adaptBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const brandCreateSlice = createSlice({
	name: 'brandCreateSlice',
	initialState,
	reducers: {
		clearBrandCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[brandCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[brandCreateApi.fulfilled.type]: (state, action: PayloadAction<TBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[brandCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useBrandCreateSelector = () => useAppSelector(state => state[brandCreateSlice.name]);

export const { clearBrandCreate } = brandCreateSlice.actions;
